import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  getGroupedEquipments,
  createEquipment,
  fetchEquipment,
  updateEquipment,
  delEquipment,
} from '../../services/equipment'

export const fetchEquipmentByIdAction = createAsyncThunk('equipments/load', async (id, { rejectWithValue }) => {
  try {
    const data = await fetchEquipment(id)
    return data.data
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const getEquipmentsAction = createAsyncThunk(
  'equipments/get',
  async ({ filters, pagination }, { rejectWithValue }) => {
    try {
      const data = await getGroupedEquipments(filters, pagination)
      return data.data
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const createEquipmentAction = createAsyncThunk(
  'equipments/create',
  async ({ name, serial_number, issue_year, price, description, images }, { rejectWithValue }) => {
    try {
      const response = await createEquipment({
        data: { data: { name, serial_number, issue_year, price, description, images } },
      })
      return response.data
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const updateEquipmentAction = createAsyncThunk(
  'equipments/update',
  async ({ id, name, serial_number, issue_year, price, description, images }, { rejectWithValue }) => {
    try {
      const response = await updateEquipment(id, {
        data: { id, name, serial_number, issue_year, price, description, images },
      })
      return response.data
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const deleteEquipmentAction = createAsyncThunk('equipments/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await delEquipment(id)
    return response.data
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const equipmentSlice = createSlice({
  name: 'equipment',
  initialState: {
    equipments: [],
    pagination: {},
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
  extraReducers: {
    [getEquipmentsAction.pending]: (state) => {
      state.isFetching = true
    },
    [getEquipmentsAction.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [getEquipmentsAction.fulfilled]: (state, data) => {
      state.equipments = data.payload.data
      state.pagination = data.payload.meta.pagination
      state.isFetching = false
      state.isSuccess = true
      return state
    },
  },
})

export const equipmentSelector = (state) => state.equipment
